<template>
  <div class="block-datos-resumen cl">
    <div>
      <h3 class="title">Propietario</h3>

      <dl class="contenido">
        <dt>¿Es tomador?:</dt>
        <dd>{{ resumen.propietario.tomador | booleanFilter }}</dd>
        <span v-if="resumen.propietario.fecNacimiento">
          <dt>Fecha de nacimiento:</dt>
          <dd>{{ resumen.propietario.fecNacimiento | dateDDMMYYYY_slash }}</dd>
        </span>
        <span v-if="resumen.propietario.tipoEmpresa">
          <dt>Tipo de empresa:</dt>
          <dd>{{ resumen.propietario.tipoEmpresa }}</dd>
        </span>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  store: ["step"],

  props: {
    resumen: {
      type: Object
    }
  }
};
</script>

<style></style>
